import { Path } from '@/main/router/routerPath';
import ArchyvPohybuDokladuList from '@/modules/noveVozy/pages/ArchyvPohybuDokladuList.vue';
import VozyNaCesteList from '@/modules/noveVozy/pages/VozyNaCesteList.vue';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import List from './List.vue';
import Edit from './Dms3Edit.vue';

export const router = new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_KEY)
	.addChildren([
		new Path('ArchyvPohybuDokladu', { List: ArchyvPohybuDokladuList }, 'NV_PohybDokl'),
		new Path('VozyNaCeste', { List: VozyNaCesteList }, 'NV_NaCeste'),
	]);
